import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { SectionHeader } from './SectionHeader';

export const ShopByGender = ({ genderCategories }) => {
  return (
    <section className="py-12 md:py-16 bg-[#F5F5F5]" data-testid="shop-by-gender">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-12">
        <SectionHeader 
          title="SHOP BY GENDER"
          subtitle="Find Jewelry for Women, Men, and Kids"
        />
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {genderCategories.map((category, index) => (
            <motion.div
              key={category.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.15 }}
            >
              <Link
                to={category.link}
                className="group block relative overflow-hidden rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300"
                data-testid={`gender-${category.id}`}
              >
                <div className="aspect-[4/5]">
                  <img src={category.image} alt={category.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" style={category.focal_x != null ? { objectPosition: `${category.focal_x}% ${category.focal_y ?? 50}%` } : undefined} loading="lazy" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent" />
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-6 text-center">
                  <h3 className="font-serif text-xl md:text-2xl text-white font-semibold mb-2">{category.name}</h3>
                  <span className="inline-flex items-center justify-center bg-[#C9A967] text-white px-6 py-2 rounded-full text-sm font-medium group-hover:bg-[#B8860B] transition-colors">
                    Shop Now
                  </span>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
